import * as coreTranslationsEN from "./en";

const {
  commonEN,
  authEN,
  rolesEN,
  customersEN,
  ordersEN,
  cookiesEN,
  accountConfigEN,
  commercialCriteriaEN,
  billingContextEN,
  areaEN,
  countryEN,
} = coreTranslationsEN;

export const coreEN = {
  common: commonEN,
  auth: authEN,
  roles: rolesEN,
  customers: customersEN,
  orders: ordersEN,
  cookies: cookiesEN,
  accountConfig: accountConfigEN,
  commercialCriteria: commercialCriteriaEN,
  billingContext: billingContextEN,
  area: areaEN,
  country: countryEN,
};
